import request from '@/request/request'
let baseURL =  global.$config.api.system_url + '/emergency-server/'
// 新增避难场所
export function save(data) {
    return request({
        baseURL,
        url: '/emergencyRefuge/save',
        method: 'post',
        data
    })
}
//修改避难场所
export function update(data) {
    return request({
        baseURL,
        url: '/emergencyRefuge/update',
        method: 'post',
        data
    })
}
//查询避难场所列表
export function list(params) {
    return request({
        baseURL,
        url: '/emergencyRefuge/list',
        method: 'get',
        params
    })
}
//查询避难场所
export function detail(id) {
    return request({
        baseURL,
        url: '/emergencyRefuge/detail?id=' + id,
        method: 'get',
    })
}
//删除避难场所
export function remove(data) {
    return request({
        baseURL,
        url: '/emergencyRefuge/remove',
        method: 'post',
        data: { ...data, isFormData:true }
    })
}